import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../../helpers/string-helper';

@Pipe({
  name: 'personName'
})
export class PersonNamePipe implements PipeTransform {
  transform(firstName: string, lastName: string) {
    return StringHelper.join([firstName, lastName], ' ');
  }
}
